"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTypeEnum = void 0;
var EntityTypeEnum;
(function (EntityTypeEnum) {
  EntityTypeEnum[EntityTypeEnum["lesson"] = 1] = "lesson";
  /** @deprecated @use EntityTypeEnum.lesson */
  EntityTypeEnum[EntityTypeEnum["content"] = 1] = "content";
  EntityTypeEnum[EntityTypeEnum["meeting"] = 2] = "meeting";
  EntityTypeEnum[EntityTypeEnum["subject"] = 3] = "subject";
  EntityTypeEnum[EntityTypeEnum["collection"] = 4] = "collection";
  EntityTypeEnum[EntityTypeEnum["classroom"] = 5] = "classroom";
  EntityTypeEnum[EntityTypeEnum["user_service"] = 6] = "user_service";
  EntityTypeEnum[EntityTypeEnum["account"] = 7] = "account";
  EntityTypeEnum[EntityTypeEnum["school"] = 8] = "school";
})(EntityTypeEnum = exports.EntityTypeEnum || (exports.EntityTypeEnum = {}));
